import { useCtx } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import { useState } from 'react'
import { css } from 'styled-components'

import {
  reatomAggregatedPosition,
  type AggregatedPositionModel,
  type WalletPositionModel,
} from '@root/entities/position'
import { PositionsTable } from '@root/features/trade/position/positions-table'
import { WalletPositionsDialog } from '@root/features/trade/position/wallet-positions-dialog/ui'

import type { PositionsTableModel } from '@root/features/trade/position/positions-table/atoms'

type Props = {
  model: PositionsTableModel
}

export const TradePositionsTable: React.FC<Props> = ({ model }) => {
  const ctx = useCtx()

  const [activePosition, setActivePosition] = useState<
    AggregatedPositionModel | undefined
  >()

  const handleRowClick = (
    position: AggregatedPositionModel | WalletPositionModel,
  ) => {
    if (reatomAggregatedPosition.is(position)) {
      const walletPositions = ctx.get(position.walletPositions)
      if (walletPositions.length > 1) {
        setActivePosition(position)
      }
    }
  }

  return (
    <>
      <PositionsTable
        css={css`
          height: 100%;
        `}
        model={model}
        onRowClick={handleRowClick}
      />
      <AnimatePresence>
        {activePosition ? (
          <WalletPositionsDialog
            position={activePosition}
            open={true}
            onOpenChange={() => setActivePosition(undefined)}
          />
        ) : undefined}
      </AnimatePresence>
    </>
  )
}
